// 坐标来源：src/assets/design/manifest-board1.json -> sections.milestone
// 全部为 752 设计稿页面绝对坐标 [left, top]（或 [left, top, width, height]），单位 px
export const SECTION_TOP = 1239
export const SECTION_HEIGHT = 1681 // 1239 ~ 2920

// 行卡内部件相对卡片左上角的统一偏移（取自 manifest 第 2 行整数坐标）
export const ROW = {
  width: 531.3,
  height: 100.8,
  circle: { dx: 43.4, dy: 10, size: 81 },
  btn: { dx: 407.6, dy: 29.4, width: 119.1, height: 42.1 },
  name: { dx: 135, width: 262 },
}

export const CHECK_SIZE = 57.7

// icons 为页面绝对坐标；img 对应 Milestone/index.vue 里的图片导入 key
export const DESIGN_ROWS = [
  {
    target: 1,
    reward: { propId: '90501244', propCount: 1 },
    card: [164.1, 1520.9],
    label: [98, 1562],
    dot: [62.4, 1557.6, 22.9],
    icons: [], // 设计稿未提供 Avatar Frame 图标切图
  },
  {
    target: 10,
    reward: { propId: '70100004', propCount: 100000 },
    card: [164, 1631],
    label: [98, 1670],
    dot: [62.8, 1668.2, 21.9],
    icons: [{ img: 'cardPoint', rect: [211, 1642, 77, 74] }],
  },
  {
    target: 20,
    reward: { propId: '80102101', propCount: 2 },
    card: [164.1, 1740.8],
    label: [98, 1779],
    dot: [62.8, 1779, 21.9],
    icons: [{ img: 'ticket', rect: [203, 1757, 77, 74] }],
  },
  {
    target: 30,
    reward: { propId: '81010999', propCount: 10 },
    card: [165.1, 1849.5],
    label: [98, 1887],
    dot: [62.4, 1888.3, 22.9],
    icons: [], // 设计稿未提供 Title 图标切图
  },
  {
    target: 40,
    reward: { propId: '70100013', propCount: 30 },
    card: [164.2, 1959.8],
    label: [98, 1996],
    dot: [62.8, 1998.8, 21.9],
    icons: [{ img: 'voucher', rect: [215, 1971, 69, 79] }],
  },
  {
    target: 50,
    reward: { propId: '80102101', propCount: 3 },
    card: [164.8, 2070.6],
    label: [98, 2104],
    dot: [62.8, 2108.7, 21.9],
    icons: [{ img: 'ticket', rect: [204, 2086, 77, 74] }],
  },
  {
    target: 60,
    reward: { propId: '70100011', propCount: 3000000 },
    card: [163.9, 2181],
    label: [98, 2213],
    dot: [62.8, 2219.5, 21.9],
    icons: [
      { img: 'goldA', rect: [223, 2203, 49, 50] },
      { img: 'goldB', rect: [210, 2216, 38, 37] },
      { img: 'goldC', rect: [247, 2219, 38, 38] },
    ],
  },
  {
    target: 70,
    reward: { propId: '80102101', propCount: 5 },
    card: [163.1, 2290.5],
    label: [98, 2321],
    dot: [62.8, 2329.3, 21.9],
    icons: [{ img: 'ticket', rect: [204, 2305, 77, 75] }],
  },
  {
    target: 80,
    reward: { propId: '90301911', propCount: 1 },
    card: [162.2, 2400.8],
    label: [101, 2437],
    dot: [62.3, 2444.3, 21.8],
    icons: [], // 设计稿未提供 Pendant 图标切图
  },
  {
    target: 90,
    reward: { propId: '70100014', propCount: 1 },
    card: [162.8, 2511.6],
    label: [101, 2546],
    dot: [62.3, 2555.2, 21.8],
    icons: [{ img: 'key', rect: [217, 2531, 62, 66] }],
  },
  {
    target: 100,
    reward: { propId: '10101404', propCount: 1 },
    card: [161.9, 2622],
    label: [101, 2654],
    dot: [62.3, 2665, 21.8],
    icons: [{ img: 'an94', rect: [172, 2630, 178, 79] }],
  },
]
